import React from 'react'
import styled from 'styled-components'
import bgImg from '../../Asset/img/sheap.png'
import boxImg from '../../Asset/img/bluspace.png'
const Why = () => {
  return (
    <WhyWrapper>
          <div className='overlay'>
           <WhyChooseWrapper>
             <LeftWrapper>
                      <span>|| Why Choose Us</span>
                      <h1>Some Reason For Choose Our Services</h1>
                      <p>Lorem, ipsum dolor sit amet consectetur adipisicing elit. Dolor debitis laudantium alias eligendi. Molestiae vel sequi doloribus corporis, voluptas repellendus?</p>
                      <div role='button' className="btn">
                          Get In Touch
                      </div>
             </LeftWrapper>
             <RightWrapper>
               <div className="BoxCon">
                <img src={boxImg} alt="our-logo" />
               </div>
             </RightWrapper>
           </WhyChooseWrapper>
          </div>  
    </WhyWrapper>
  )
}

const WhyWrapper = styled.section`
position: relative;
 background-image: url(${bgImg});
 background-size: cover;
 background-position: center;
 min-height: 85vh;

 .overlay{
    padding: 80px 0;
    position: absolute;
    width: 100%;
    height: 100%;
    background: linear-gradient(175deg, rgb(1, 35, 49), rgba(3, 14, 26, 0.904));
 }

 @media screen and (max-width: 884px){
  min-height: 50vh;
 }

 @media screen and (max-width: 768px){
  min-height: 60vh;
 }

 @media screen and (max-width: 430px){
  min-height: 90vh;
 }
`

const WhyChooseWrapper = styled.article`
 width: calc(100% - 20px);
 display: grid;
 grid-template-columns: 63% 35%;
 gap: 2%;
 margin: 0 auto;
 padding: 30px;
 @media screen and (max-width: 430px){
  grid-template-columns: 100%;
  padding: 10px;
 }
`

const LeftWrapper = styled.div`
 background: var(--ico-bg);

 span{
    color: #fff;
    font-weight: 700;
 }

 h1{
    color: var(--main-color);
    font-size: 2.6rem;
    padding: 15px 0;
    width: 60%;
 }

 p{
    color: var(--main-color);
    font-size: 1.05rem;
    font-weight: 600;
    line-height: 1.7;
    max-width: 500px;
 }

 .btn{
    padding: 15px;
    width: 30%;
    background: var(--main-color);
    border-radius: 50px;
    box-shadow: 0 0.5rem 1rem var(--text-color);
    cursor: pointer;
    color: var(--bg-color);
    font-size: 1.05rem;
    font-weight: 700;
    text-align: center;
    margin-top: 15px;
    transition: transform 600ms ease-in-out;

    &:active{
        transform: scale(0.95);
    }
 }


 @media screen and (max-width: 884px){
  h1{
   font-size: 2.6rem;
   width: 100%;
  }
  p{
   min-width: 400px;
  }
  .btn{
   width: 60%;
   margin: 20px 0;
  }
 }

 @media screen and (max-width: 768px){
  h1{
   font-size: 2rem;
   width: 100%;
  }
  p{
   min-width: 400px;
  }
  .btn{
   width: 60%;
   margin: 20px 0;
  }
 }

 @media screen and (max-width: 430px){
  h1{
   font-size: 2rem;
   width: 100%;
  }
  p{
   min-width: 400px;
  }
  .btn{
   width: 60%;
   margin: 20px 0;
  }
 }
`
const RightWrapper = styled.div`
 .BoxCon{
    background: rgb(255, 254, 254);
    box-shadow: 0 .5rem 1rem rgb(0 0 0 / 15%);
    border-radius: .2rem;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 75vh;
    transform: translateY(-10rem);
    img{
        width: 80%;
        margin: 0 auto;
    }
 }


 @media screen and (max-width: 884px){
  .BoxCon{
   height: 30vh;
   width: 100%;
   transform: translate(0);
  }
 }

 @media screen and (max-width: 768px){
  .BoxCon{
   height: 30vh;
   width: 100%;
   transform: translate(0);
  }
 }

 @media screen and (max-width: 430px){
  .BoxCon{
   height: 30vh;
   transform: translate(0);
  }
 }
 
`
export default Why